import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class GroupRoleExistsError extends CodedError {
  static get errorName() {
    return errorCodes.groupRoleExistsError.code;
  }

  constructor(message: string = errorCodes.groupRoleExistsError.message) {
    super(message);
    this.code = errorCodes.groupRoleExistsError.code;
    this.message = `${message} ${errorCodes.groupRoleExistsError.code}`;
    this.name = errorCodes.groupRoleExistsError.name;
  }
}
